// extracted by mini-css-extract-plugin
module.exports = {"description":"ContentBlockVkVideo_description__D2_u_","iframeWrapper":"ContentBlockVkVideo_iframeWrapper__fpeU5","iframe":"ContentBlockVkVideo_iframe__vaCsR"};